import * as React from 'react';

import {EntityPillSelectWrapperSmall} from '../entity-pill/entity-pill-select-wrapper-small';

import styles from './select-inline.module.css';

const COLOR_NAME_STYLES = ['colorName', 'leftBorder'];

export type TokenStyle =
    | 'leads'
    | 'users'
    | 'teams'
    | 'contacts'
    | 'accounts'
    | 'dark'
    | 'light'
    | 'colorName'
    | 'leftBorder'
    | 'none';

type Props = {
    data: any;
    onRemove?: () => void;
    shouldStyleValueByType?: boolean;
    tokenizedStyle: TokenStyle;
    labelKey: string;
    valueKey: string;
    isTwoLine?: boolean;
};

export function ValueComponent(props: Props) {
    const {data, onRemove, shouldStyleValueByType, tokenizedStyle, labelKey, valueKey, isTwoLine} =
        props;
    let iconNode = null;
    if (data.icon) {
        const IconComponent = data.icon;
        iconNode = <IconComponent size={14} wrapWithDiv={false} alignCenter={true} />;
    }

    // EntityPill expects id and name, but technically we
    // can pass any combination of label and valueKey to
    // this component. We'll map those values here.
    const nameNode = iconNode ? (
        <div className='flex gap-4 align-center'>
            {iconNode}
            <span>{data[labelKey]}</span>
        </div>
    ) : (
        data[labelKey]
    );

    const entityPillData = {
        ...data,
        id: data[valueKey],
        name: nameNode,
    } as const;

    if (shouldStyleValueByType) {
        return (
            <EntityPillSelectWrapperSmall
                type={data.type}
                value={entityPillData}
                sublabel={isTwoLine ? data.description : undefined}
                onRemove={onRemove}
            />
        );
    }

    if (tokenizedStyle) {
        const shouldPassColorName = COLOR_NAME_STYLES.includes(tokenizedStyle);

        return (
            <EntityPillSelectWrapperSmall
                type={tokenizedStyle}
                value={entityPillData}
                sublabel={isTwoLine ? data.description : undefined}
                onRemove={onRemove}
                colorName={shouldPassColorName ? data.colorName : undefined}
            />
        );
    } else {
        // There is no removal option for untokenized items.
        // Only use untokenized styling for non-removable options
        return <span className={styles['untokenized']}>{entityPillData.name}</span>;
    }
}
